module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4c3354f5536cc0d79df7350b80aa3ef1.png";